import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { enviroment } from "../../../enviroment";
import { useMinuteTick } from "../../../hooks/useMinuteTick";
import {
  storageAgeLabel,
  storageUpdatedLabel,
} from "../../../utils/functions/storageUpdatedAt";

interface Props {
  storageUpdatedAtUtc?: string | null;
  className?: string;
}

// One muted caption line under a storage count (cart line, design logo, logo
// detail, logo list): a clock icon and the stamp's age - "just now",
// "12 min ago", "3 h ago", "2 d ago" or "not verified" - with the full
// "Stock updated 07/09/2026 11:34" / "Stock not verified yet" as the
// tooltip. Gated by checkoutStorageVerifyEnabled (the checkout storage
// verify) or storageFreshnessEnabled (stock freshness on view) - the flags of
// the two mechanisms that keep the stamp fresh; with both off it renders
// nothing and subscribes to nothing (no hook, no minute clock), so the DOM
// and the page's timers stay byte-identical. No calls: the stamp rides on
// the logo the page already has; the age is re-read once a minute by the
// page's one shared clock.
export function StorageUpdatedAt(props: Props) {
  if (
    !enviroment.checkoutStorageVerifyEnabled &&
    !enviroment.storageFreshnessEnabled
  )
    return null;
  return <StorageUpdatedAtInner {...props} />;
}

function StorageUpdatedAtInner({ storageUpdatedAtUtc, className }: Props) {
  const { t } = useTranslation();
  useMinuteTick();
  const now = Date.now();
  const full = storageUpdatedLabel(storageUpdatedAtUtc, t, now);
  return (
    <span
      title={full}
      aria-label={full}
      className={`flex items-center gap-x-1 text-[10px] leading-tight font-normal normal-case text-gray-400 whitespace-nowrap ${
        className ?? ""
      }`}
    >
      <FontAwesomeIcon icon={faClock} className="w-2.5 h-2.5" aria-hidden="true" />
      {storageAgeLabel(storageUpdatedAtUtc, t, now)}
    </span>
  );
}
